import { removeNull } from '@/utils/handleData'

export default {
  namespaced: true,
  state: {
    waterwheelWorkList: {}, // 水车作业列表
    waterwheelWorkInfo: {}
  },
  actions: {
    // 获取水车作业列表
    async getWaterwheelWorkList({ rootState, commit, dispatch }, data) {
      const queryForm =
        (rootState.queryValues && rootState.queryValues.waterwheelWork) || {}
      const period = Array.isArray(queryForm.period) ? queryForm.period : []
      var queryValues = {
        orgUid: data
          ? data.orgUid
          : queryForm.orgUid
          ? queryForm.orgUid
          : rootState.user.orgValue,
        laborCompanyUid: data ? data.laborCompanyUid : queryForm.laborCompanyUid,
        isFinished: data ? data.isFinished : queryForm.isFinished,
        query: data ? data.query : queryForm.query,
        start: data ? data.start : period[0],
        end: data ? data.end : period[1],
        page:
          data && data.page
            ? data.page
            : rootState.page.waterwheelWork
            ? rootState.page.waterwheelWork
            : 1,
        limit:
          data && data.limit
            ? data.limit
            : rootState.limit.waterwheelWork
            ? rootState.limit.waterwheelWork
            : 10
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/watertruck/operationlist',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      var waterwheelWorkList = res.data ? res.data : {}
      commit(
        'baseSet',
        {
          module: 'waterwheelWork',
          key: 'waterwheelWorkList',
          value: waterwheelWorkList
        },
        { root: true }
      )
    },
    // 新增水车作业事项
    async addWaterwheelWork({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/watertruck/operation',
          data: data,
          msg: '新增水车作业信息成功'
        },
        { root: true }
      )
      return res
    },
    // 获取水车作业信息
    async getWaterwheelWorkInfo({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/watertruck/operation',
          data: {
            uid: uid
          }
        },
        { root: true }
      )
      //console.log(res)
      var waterwheelWorkInfo = res.data ? res.data : {}
      waterwheelWorkInfo.startlnglat =
        waterwheelWorkInfo.startGps && waterwheelWorkInfo.startGps.lng
          ? waterwheelWorkInfo.startGps.lng +
            '，' +
            waterwheelWorkInfo.startGps.lat
          : ''
      waterwheelWorkInfo.endlnglat =
        waterwheelWorkInfo.endGps && waterwheelWorkInfo.endGps.lng
          ? waterwheelWorkInfo.endGps.lng + '，' + waterwheelWorkInfo.endGps.lat
          : ''
      commit(
        'baseSet',
        {
          module: 'waterwheelWork',
          key: 'waterwheelWorkInfo',
          value: waterwheelWorkInfo
        },
        { root: true }
      )
      return waterwheelWorkInfo
    },
    // 编辑水车作业信息
    async editWaterwheelWork({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/watertruck/operation',
          data: data,
          msg: '编辑水车作业信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除水车作业信息
    async deleteWaterwheelWork({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/watertruck/operation',
          data: { uid: uid },
          msg: '删除水车作业信息成功'
        },
        { root: true }
      )
      return res
    }
  }
}
